import { ThemeOption } from '../../reducers/Theme';
import { State } from '../../reducers/State';

export const appThemeSelector = (state: State): ThemeOption => {
  const theme = state.theme.app;
  if (theme === 'original' || theme === 'dark') {
    return theme;
  }
  return '';
};

export const isThemeSelectorMenuOpen = (state: State): boolean =>
  state.theme.isThemeSelectorMenuOpen;
